//This module contains the translations for the G.U.C. Coaching website in multiple languages.
export const translations = {
    en: {
        title: `G.U.C. Coaching`,
        about: "About",
        services: "Services",
        stats: "Stats",
        contact: "Contact",
        heroTitle: "Growing Under Control",
        heroSubtitle: "Elite training. Tailored nutrition. Next-level results.",
        heroCTA: "Start Transformation",
        aboutTitle: "About Me",
        aboutText:
            "I'm a certified personal trainer with over 8 years of experience helping clients build muscle, burn fat, and master discipline. My mission is to transform not only physiques but lives — with proven methods, tailored support, and relentless energy.",
        servicesTitle: "Services",
        lifestyleCoaching: "Personal Training",
        lifestyleText:
            "Optimize your habits, manage stress, and create a routine that fits your lifestyle. Daily success starts here.",
        onlineCoach: "Online Coaching",
        onlineCoachingText:
            "Get tailored supplement advice to boost performance, recovery, and overall health — fully remote and effective.",
        workoutPlans: "Workout Plans",
        workoutText:
            "Custom strength and hypertrophy plans built around your goals and physique. Train smarter, grow stronger.",
        mealPlan: "Meal Plans",
        mealPlansText:
            "Science-backed meal plans for fat loss, muscle building, or stepping on stage. Fuel your goals the right way.",
        nutritionCoaching: "Supplement Guidance & Nutrition Coaching",
        nutritionText:
            "Your roadmap to better results. Expert nutrition and supplement strategies for fat loss, muscle gain, or prep.",
        fitRecipes: "Fit Recipes",
        fitRecipesText:
            "Easy-to-follow recipe plans for your fitness goals. Healthy eating doesn’t have to be boring — or complicated.",
        statsTitle: "My Results",
        clients: "Clients Transformed",
        experience: "Years Experience",
        competitions: "Competitions Coached",
        reviews: "5-Star Reviews",
        statsText:
            "These numbers reflect more than progress — they represent dedication, transformation, and unstoppable momentum.",
        contactTitle: "Contact",
        yourName: "Your Name",
        yourPhone: "Your Phone Number",
        yourEmail: "Your Email",
        yourMessage: "Your Message",
        sendMessage: "Send Message",
        footerText: "All rights reserved.",
        footerBuilt: "Built with ❤️ by",
        lifestyle: "Your Personalized Path to Strength, Structure & Results",
        lifestyleModalText: `Unlock your full potential through personalized one-on-one coaching that adapts to your lifestyle, experience level, and goals.
Together, we’ll build a sustainable routine that maximizes your performance, boosts your confidence, and helps you manage stress more effectively.
From tailored training plans to daily habit guidance, I’ll help you stay accountable and focused — because true progress starts with structure.
Daily wins, long-term transformation. Let’s get to work.`,

        onlineCoaching: "Remote Coaching. Real Results.",
        onlineCoachingModalText: `No matter where you are, you’ll get the expert guidance and support you need to stay on track and reach your fitness goals.
With structured check-ins, adaptive plans, and personal accountability, online coaching brings the gym to your lifestyle.
We’ll combine strategic adjustments with consistent motivation so you never feel lost — just stronger, smarter, and more in control every week.`,

        workouts: "Tailored Workout Plans That Build Real Strength",
        workoutsModalText: `Get the structure and strategy you need to make every training session count.
Whether you’re training for performance, aesthetics, or personal achievement, your custom workout plan will reflect your goals, time, and body type.
We’ll optimize your splits, rep ranges, and progression — all designed to help you grow, not plateau. Results are earned, not guessed.`,

        mealPlans: "Custom Meal Plans for Fueling Transformation",
        mealPlansModalText: `Nutrition should support your life — not complicate it. 
With science-based meal plans designed around your goal (fat loss, muscle gain, or competition prep), you’ll get clarity and confidence in the kitchen.
Expect practical, sustainable meals that fuel energy, recovery, and progress without extreme diets or restriction.`,

        nutritions: "Supplement & Nutrition Coaching with Purpose",
        nutritionsModalText: `Navigating the supplement world and dialing in your macros doesn’t have to be overwhelming.
With my coaching, you’ll get evidence-based recommendations that enhance performance, recovery, and overall wellness.
From understanding timing and dosage to tailoring your intake to your training and metabolism — I’ll guide you every step of the way.`,

        recipes: "Fit-Friendly Recipes That Actually Taste Good",
        recipesModalText: `Eating healthy should be simple, enjoyable, and aligned with your fitness journey.
These recipe solutions are crafted to support your physique goals while keeping flavor on the plate.
From quick prep meals to creative twists on classics, you’ll have access to easy, macro-friendly recipes that fuel your progress — and your cravings.`,

        ///Personal traning
        ///Workout plan
        ///Online coaching
        ///Supplement guidance and nutrition coaching
        ///Mealplan
        ///Receipts
    },
    hu: {
        title: "G.U.C. Coaching",
        about: "Rólam",
        services: "Szolgáltatások",
        stats: "Eredmények",
        contact: "Kapcsolat",
        heroTitle: "Growing Under Control",
        heroSubtitle:
            "Professzionális edzés. Személyre szabott táplálkozás. Látványos eredmények.",
        heroCTA: "Kezdd el az átalakulást",
        aboutTitle: "Rólam",
        aboutText:
            "Tanúsított személyi edző vagyok, több mint 8 év tapasztalattal. Segítek az ügyfeleknek izmot építeni, zsírt égetni, és elsajátítani a fegyelmet. Küldetésem, hogy ne csak a testeket, hanem életeket is átalakítsak – bizonyított módszerekkel, személyre szabott támogatással és fáradhatatlan energiával.",
        servicesTitle: "Szolgáltatások",
        lifestyleCoaching: "Személyi Edzés",
        lifestyleText:
            "Optimalizáld a szokásaidat, kezeld a stresszt, és alakíts ki egy életstílusodhoz illő rutint. A napi siker itt kezdődik.",
        onlineCoach: "Online Tanácsadás",
        onlineCoachingText:
            "Személyre szabott táplálékkiegészítő tanácsadás a teljesítmény, regeneráció és egészség támogatására – teljesen online.",
        workoutPlans: "Edzéstervek",
        workoutText:
            "Egyéni erő- és izomtömeg-növelő edzéstervek, a céljaidhoz és testedhez igazítva. Edz okosan, fejlődj hatékonyan.",
        mealPlan: "Étrendek",
        mealPlansText:
            "Tudományos alapú étrendek fogyáshoz, izomépítéshez vagy versenyfelkészüléshez. Tápláld helyesen a céljaidat.",
        nutritionCoaching: "Táplálékkiegészítő- & Táplálkozási Tanácsadás",
        nutritionText:
            "Útmutató a jobb eredményekhez: profi étrend- és kiegészítő-stratégiák fogyáshoz, izomépítéshez vagy felkészüléshez.",
        fitRecipes: "Fitt Receptek",
        fitRecipesText:
            "Egyszerű, célorientált recepttervek az egészséges életmódhoz. Az egészséges étkezés lehet finom és élvezetes is.",
        statsTitle: "Eredményeim",
        clients: "Átalakított ügyfelek",
        experience: "Év tapasztalat",
        competitions: "Edzett versenyzők",
        reviews: "5 csillagos értékelés",
        statsText:
            "Ezek a számok többet jelentenek, mint puszta fejlődés – elkötelezettséget, átalakulást és megállíthatatlan lendületet képviselnek.",
        contactTitle: "Kapcsolat",
        yourName: "Neved",
        yourEmail: "Email címed",
        yourPhone: "Telefonszámod",
        yourMessage: "Üzeneted",
        sendMessage: "Üzenet küldése",
        footerText: "Minden jog fenntartva.",
        footerBuilt: "❤️-el készítette:",
        lifestyle: "Személyre szabott út az erőhöz, struktúrához és eredményekhez",
        lifestyleModalText: `Hozd ki magadból a legtöbbet egyéni, személyre szabott edzésprogrammal, amely igazodik az életmódodhoz, szintjeidhez és céljaidhoz.
Közösen kialakítunk egy fenntartható rutint, amely növeli a teljesítményed, erősíti az önbizalmad, és segít hatékonyabban kezelni a stresszt.
Az egyénre szabott edzéstervektől a napi szokások optimalizálásáig végig támogatlak – mert az igazi fejlődés struktúrával kezdődik.
Napi sikerekből lesz a tartós átalakulás. Vágjunk bele!`,

        onlineCoaching: "Online támogatás. Valódi eredmények.",
        onlineCoachingModalText: `Bárhol is vagy, megkapod a szakértői támogatást, amivel nemcsak tartani tudod a céljaidat, hanem túl is szárnyalhatod azokat.
Strukturált visszajelzések, személyre szabott tervmódosítások és folyamatos motiváció segítik az utadat.
Az online coaching révén az edzés ott lesz veled, ahol csak vagy — fókuszáltan, hatékonyan, eredményesen.`,

        workouts: "Egyéni edzéstervek valódi fejlődéshez",
        workoutsModalText: `Megkapod a struktúrát és stratégiát, amire szükséged van ahhoz, hogy minden edzés számítson.
Akár esztétikai, akár teljesítménycélokat tűztél ki, az edzésterved a testedhez, idődhöz és céljaidhoz lesz igazítva.
Split, ismétlésszám, progresszió – minden úgy lesz tervezve, hogy ne stagnálj, hanem fejlődj.`,

        mealPlans: "Személyre szabott étrendek az átalakuláshoz",
        mealPlansModalText: `A táplálkozás legyen a támogatód, ne az ellenséged. 
Olyan tudományos alapú étrendeket kapsz, amelyek pontosan a te céljaidhoz igazodnak: legyen szó zsírégetésről, izomnövelésről vagy versenyfelkészülésről.
Egyszerű, fenntartható, ízletes – nincs többé káosz a konyhában, csak tiszta irány.`,

        nutritions: "Táplálkozási és kiegészítő tanácsadás, céllal",
        nutritionsModalText: `Nem kell elveszned a táplálékkiegészítők és makrók világában.
Segítek eligazodni az adagolásban, időzítésben és a személyre szabott beállításokban is – edzettségi szintedhez és életmódodhoz igazítva.
Célzott támogatás a teljesítményedhez, regenerációdhoz és egészségedhez.`,

        recipes: "Egészséges receptek, amiket szívesen eszel is",
        recipesModalText: `Az egészséges étkezés legyen egyszerű és élvezetes – nem unalmas és bonyolult.
Ezek a receptek támogatják a fizikai céljaidat, miközben finomak, gyorsan elkészíthetők és könnyen beilleszthetők a mindennapokba.
Makróbarát fogások, amik nem áldozzák fel az ízt a cél oltárán.`,
    },
    nl: {
        title: "G.U.C. Coaching",
        about: "Over Mij",
        services: "Diensten",
        stats: "Resultaten",
        contact: "Contact",
        heroTitle: "Growing Under Control",
        heroSubtitle:
            "Elite training. Gepersonaliseerde voeding. Resultaten op een hoger niveau.",
        heroCTA: "Start je Transformatie",
        aboutTitle: "Over Mij",
        aboutText:
            "Ik ben een gecertificeerde personal trainer met meer dan 10 jaar ervaring. Ik help klanten met spieropbouw, vetverlies en het ontwikkelen van discipline. Mijn missie is om niet alleen lichamen, maar levens te transformeren — met bewezen methoden, persoonlijke begeleiding en eindeloze energie.",
        servicesTitle: "Diensten",
        lifestyleCoaching: "Persoonlijke training",
        lifestyleText:
            "Optimaliseer je gewoontes, beheer stress en bouw een routine die past bij jouw leven. Dagelijks succes begint hier.",
        onlineCoach: "Online Coaching",
        onlineCoachingText:
            "Persoonlijk supplementadvies voor betere prestaties, herstel en gezondheid – volledig online en effectief.",
        workoutPlans: "Trainingsschema’s",
        workoutText:
            "Persoonlijke kracht- en spieropbouwschema’s afgestemd op jouw lichaam en doelen. Train slimmer, groei sterker.",
        mealPlan: "Maaltijdschema’s",
        mealPlansText:
            "Wetenschappelijk onderbouwde maaltijdschema’s voor vetverlies, spieropbouw of wedstrijdvoorbereiding. Voed je doelen op de juiste manier.",
        nutritionCoaching: "Supplementadvies & Voedingscoaching",
        nutritionText:
            "Jouw route naar betere resultaten. Voedings- en supplementstrategieën van experts voor vetverlies, spiergroei of prep.",
        fitRecipes: "Fit Recepten",
        fitRecipesText:
            "Makkelijke, doelgerichte recepten voor jouw fitnesstraject. Gezond eten hoeft niet saai of ingewikkeld te zijn.",
        statsTitle: "Mijn Resultaten",
        clients: "Getransformeerde Klanten",
        experience: "Jaren Ervaring",
        competitions: "Begeleide Wedstrijden",
        reviews: "5-sterren Beoordelingen",
        statsText:
            "Deze cijfers staan voor meer dan vooruitgang — ze vertegenwoordigen toewijding, transformatie en niet te stoppen motivatie.",
        contactTitle: "Contact",
        yourName: "Je Naam",
        yourEmail: "Je E-mailadres",
        yourPhone: "Je Telefoonnummer",
        yourMessage: "Je Bericht",
        sendMessage: "Bericht Versturen",
        footerText: "Alle rechten voorbehouden.",
        footerBuilt: "Gemaakt met ❤️ door",
        lifestyle: "Jouw Persoonlijke Route naar Kracht, Structuur & Resultaat",
        lifestyleModalText: `Ontgrendel je volledige potentieel met gepersonaliseerde één-op-één coaching die aansluit bij jouw levensstijl, ervaringsniveau en doelen.
Samen bouwen we een duurzaam schema dat je prestaties maximaliseert, je zelfvertrouwen vergroot en helpt om stress effectief te beheersen.
Van trainingsplannen op maat tot dagelijkse gewoontebegeleiding – ik help je gefocust en verantwoordelijk te blijven. 
Dagelijkse overwinningen vormen langdurige transformatie. Let’s go!`,

        onlineCoaching: "Online Coaching. Echte Resultaten.",
        onlineCoachingModalText: `Waar je ook bent, je krijgt de begeleiding en motivatie die je nodig hebt om op koers te blijven en je fitnessdoelen te bereiken.
Met gestructureerde check-ins, flexibele plannen en persoonlijke betrokkenheid is online coaching net zo effectief als fysiek — misschien zelfs meer.
Altijd ondersteuning, altijd richting, altijd resultaat.`,

        workouts: "Op Maat Gemaakte Trainingsschema’s voor Echte Groei",
        workoutsModalText: `Structuur en strategie zijn essentieel — en precies dat krijg je hier.
Of je nu traint voor prestaties, esthetiek of persoonlijke doelen: jouw schema wordt volledig afgestemd op jouw lichaam, tijd en ambitie.
Progressieve overload, gebalanceerde splits en slimme opbouw – voor blijvend resultaat, geen stilstand.`,

        mealPlans: "Maaltijdschema’s die je Doelen Voeden",
        mealPlansModalText: `Voeding hoort jouw bondgenoot te zijn, geen obstakel.
Met wetenschappelijk onderbouwde schema’s afgestemd op vetverlies, spiergroei of wedstrijdvoorbereiding, weet je precies wat en waarom je eet.
Praktisch, voedzaam, haalbaar – zonder crashdiëten of verwarring.`,

        nutritions: "Supplementadvies & Voeding die Werkt voor Jou",
        nutritionsModalText: `Supplementen en macro’s hoeven geen doolhof te zijn.
Ik geef je advies op basis van wetenschap en ervaring, afgestemd op jouw levensstijl en fysieke behoeften.
Van timing tot dosering – alles wordt begrijpelijk en effectief gemaakt.`,

        recipes: "Gezonde Recepten die Écht Lekker Zijn",
        recipesModalText: `Gezond eten mag nooit saai zijn. 
Deze recepten zijn ontworpen om jouw fysieke doelen te ondersteunen en tegelijkertijd smaakvol en eenvoudig te blijven.
Snelle maaltijden, slimme variaties – voeding waar je naar uitkijkt én op kunt bouwen.`,
    },
};
